// context/PushNotificationContext.js
import React, { createContext, useContext } from 'react';
import { usePushNotifications } from '../usePushNotifications';
import { AuthContext } from './AuthContext';

const PushNotificationContext = createContext(null);

// Single source of truth for push state. Mounted once, high up in the
// tree, so every consumer (Navbar, auto-subscribe, anywhere else) reads
// the same subscribed/loading/error state instead of each spinning up
// its own hook instance with its own duplicate network calls.
export function PushNotificationProvider({ children }) {
  const { isAuthenticated } = useContext(AuthContext);
  const pushState = usePushNotifications(isAuthenticated);

  return (
    <PushNotificationContext.Provider value={pushState}>
      {children}
    </PushNotificationContext.Provider>
  );
}

// Consumer hook — throws early if someone forgets to wrap the tree in
// the provider, instead of silently getting `null` and crashing later
// on `undefined.supported`.
export function usePushNotificationContext() {
  const ctx = useContext(PushNotificationContext);

  if (ctx === null) {
    throw new Error(
      'usePushNotificationContext must be used within a PushNotificationProvider'
    );
  }

  return ctx;
}